import { useEffect } from "react";
import Lenis from "lenis";

// Provides smooth momentum scrolling across the public site.
export const SmoothScroll = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    // Allow anchor navigation via data-scroll-to
    const handleAnchor = (e) => {
      const target = e.target.closest("[data-scroll-to]");
      if (target) {
        e.preventDefault();
        const id = target.getAttribute("data-scroll-to");
        const el = document.getElementById(id);
        if (el) lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", handleAnchor);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", handleAnchor);
      lenis.destroy();
    };
  }, []);

  return children;
};
